import { ThemeOptions } from "@mui/material";
import { deepPurple } from "@mui/material/colors";

import { rydeColors } from "./parts";

export const themeMuiDefault: ThemeOptions = {
  direction: "ltr",
  palette: {
    mode: "light",
    primary: {
      main: deepPurple.A400,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // TODO this is the hack for vertical align for the icons, need to get rid of it in next refactoring, because it brake native button height for MUI buttons, on several widgets
          lineHeight: 0,
        },
      },
    },
    MuiInputBase: {
      defaultProps: {
        autoComplete: "new-password",
      },
      styleOverrides: {
        root: {
          "&::after": {
            borderBottom: "none",
          },
          "&:focus": {
            backgroundColor: rydeColors.white,
          },
        },
        input: {
          "&::placeholder": {
            color: rydeColors.placeholder,
          },
          // "&:-webkit-autofill": {
          //   transitionDelay: "9999s",
          //   transitionProperty: "background-color, color",
          // },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
          "&::after": {
            borderBottom: "none",
          },
          "&:hover": {
            backgroundColor: "#fff",
          },
          "&:focus": {
            backgroundColor: "#fff",
          },
        },
      },
    },

    MuiCheckbox: {
      styleOverrides: {
        colorPrimary: {
          color: `${rydeColors.steel} !important`,
        },
        root: {
          padding: 0,
        },
      },
    },

    MuiInput: {
      defaultProps: {
        autoComplete: "new-password",
      },
    },
    MuiTextField: {
      defaultProps: {
        autoComplete: "new-password",
        // InputLabelProps: { shrink: true },
      },
      styleOverrides: {
        root: {
          // input: {
          //   "&:-webkit-autofill": {
          //     WebkitBoxShadow: "0 0 0 100px gray inset",
          //     WebkitTextFillColor: "default",
          //   },
          //},
        },
      },
    },
  },
};
